var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExportB = function SvgExportB(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M1.667 10c0-3.929 0-5.893 1.22-7.114 1.221-1.22 3.185-1.22 7.113-1.22s5.893 0 7.113 1.22c1.22 1.222 1.22 3.185 1.22 7.113s0 5.893-1.22 7.113-3.185 1.22-7.113 1.22-5.892 0-7.113-1.22c-1.22-1.22-1.22-3.184-1.22-7.113M10 5.207a.625.625 0 0 1 .625.625v4.325l1.433-1.434a.624.624 0 1 1 .884.884l-2.5 2.5a.625.625 0 0 1-.884 0l-2.5-2.5a.625.625 0 1 1 .884-.884l1.433 1.434V5.833A.625.625 0 0 1 10 5.208M6.667 13.54a.625.625 0 0 0 0 1.25h6.666a.625.625 0 1 0 0-1.25z",
    clipRule: "evenodd"
  })));
};
export default SvgExportB;